let e={typescale:"MVP"},t=["VDS","MVP","Marketing"];var a={getTypescale:function(t){return e.typescale},settypescale:function(a){t.includes(a)&&(e.typescale=a)}};export{a as default};
